import styled from "styled-components";

import { Typography } from "@/foundation/Typography/V1";
import { Box, FlexDiv } from "@/components/Atoms/Box";

export const Heading = styled(Typography)`
  margin-bottom: 25px;
`;
export const CardBody = styled(FlexDiv)`
  background-color: ${({ theme }) => theme.colors.cardFallbackBg};
  background-image: ${({ theme }) => theme.colors.cardGradient};
  border-radius: 10px;
  padding: 30px;
  outline: 0;
  display: flex !important;
  flex-direction: column;
`;

export const TopBox = styled(Box)`
  position: relative;
  padding-bottom: 15px;
  margin-bottom: 10px;
  &:after {
    content: "";
    position: absolute;
    left: 0;
    height: 5px;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.white};
    width: 30px;
    bottom: 0;
  }
`;

export const SlideWrap = styled(FlexDiv)`
  .slick-track {
    display: flex !important;
  }

  .slick-slide {
    height: auto !important;
  }
  .slick-slider {
    width: 100%;
    .slick-dots {
      li {
        &.slick-active {
          button {
            &::before {
              background-color: ${({ theme }) => theme.colors.dotsColor};
            }
          }
        }
        button {
          position: relative;
          &::before {
            background-color: rgba(92, 92, 110, 0.2);
            border-radius: 50%;
            height: 8px;
            width: 8px;
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.3s ease-in-out;
          }
        }
      }
    }
    .slick-slide {
      & > div {
        display: flex;
        height: 100%;
        margin: 0 4.5px;
        padding: 15px 7.5px;
        @media only screen and (max-width: 767px) {
          margin: 0;
          padding: 15px;
        }
        @media only screen and (max-width: 767px) {
          padding: 15px 10px;
        }
      }
    }
  }
`;

export const UL = styled.ul`
  padding: 0;
  margin: 0;
  flex: 1;
`;

export const LI = styled.li`
  margin-bottom: 4px;
  position: relative;
  list-style: none;
  ${({ disablebullet, theme }) =>
    !disablebullet &&
    `
  padding-left: 10px;
  &:before {
    content: "";
    height: 3px;
    width: 3px;
    background-color: ${theme.colors.white};
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 10px;
    left: 0;
  }
  `};
  &:last-child {
    margin-bottom: 0;
  }
  .gold {
    color: ${({ theme }) => theme.colors.yellow2};
    font-family: var(--font-700);
    font-size: inherit;
  }
  b {
    color: inherit;
    font-family: var(--font-700);
    font-size: inherit;
  }
`;
